import { cn } from "@/lib/utils";

type SpinnerProps = {
  className?: string;
  variant?: "default" | "sm";
};

export function Spinner({ className, variant = "default" }: SpinnerProps) {
  return (
    <div
      className={cn(
        "border-2 border-zinc-400 border-t-transparent rounded-full animate-spin",
        variant === "default" ? "w-5 h-5" : "w-4 h-4",
        className,
      )}
    />
  );
}
